
import * as React from 'react';
import { useState, useEffect } from 'react';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Database } from '../../Managers/DataManager';
import { ScrollView } from '../ScrollView/ScrollView';
import "./VideoShelf.css"
import { VideoTile } from './VideoTile';

import { Fade } from '@material-ui/core';
import VisibilitySensor from 'react-visibility-sensor';
import { ImageAnimations } from '../Image/Image';

type VideoShelfProps = {
    path: string // path to get data
    title: string
}

export const VideoShelf = (props: VideoShelfProps) => {
const { path, title } = props
const [videos, setVideos] = useState([])
const [ visible, setVisible] = useState(false)


const onVisibilityChange = (visibility) => {
    // when visibility is first set to trut
    // get your data
    // do not get data on subsequent 
    // visiblility changes
    if(visible) { return } 
    setVisible(visibility)
}

const leaving = new Subject<void>()
useEffect(() => {
    if(!visible) { return }
    Database.get(path)
    .then(sub => {
        sub.pipe(takeUntil(leaving))
        .subscribe(setVideos)
    })
    .catch(console.error)

    return () => leaving.next()
}, [path, visible])


const renderItem = (item) => <VideoTile item={item} animation={ImageAnimations.scale} />

return(
    <VisibilitySensor onChange={onVisibilityChange}>
        <Fade in={visible} timeout={3000}>
         <ScrollView             
            data={videos}
            title={title}
            renderItem={renderItem}
            keyExtractor={(item) => item.uuid}
        />
        </Fade>
    </VisibilitySensor>

)

}

